import React, { Fragment, Component } from 'react'
import CollapseMenu from '../../../../config/atoms/CollapseMenu';
import MenuDetail from '../MenuDetail';
import { Link } from 'react-router-dom';
import tableAddOns from '../../../../config/atoms/TableAddOns';
import swal from 'sweetalert';
import { dataMahasiswa } from '../../../../dummy-data/mahasiswa';
import { dataKHS } from '../../../../dummy-data/krs-khs';

const $ = require("jquery");
$.Datatable = require("datatables.net");

const statusBatalMK = {
    setuju: 'setuju',
    tolak: 'tolak',
}
class HistoryBatal extends Component {

    state = {
        user: {
            angkatan: '',
            jurusan: '',
            kurikulum: '',
            nama: '',
            nim: '',
            semester: '',
            ta: '',
        },
        listBatal: {
            data: []
        },
        OptSemester: [],
        isLoading: false,
        selectedSemester: '-',
        checklist: [],
        idbatalmk: [],
        // params
        idVal: '',
        nimVal: ''
    }

    getAllData = () => {
        $('.cekKRS').prop("checked", false);
        const nim = this.state.nimVal;
        const mhs = dataMahasiswa.find(m => m.nim === nim);
        const khsData = dataKHS.filter(k => k.nim === nim);

        // Get unique semesters
        const semesters = [...new Set(khsData.map(k => k.semester_ke))].sort((a, b) => a - b);

        this.setState({
            user: {
                angkatan: mhs ? mhs.angkatan : '2020',
                jurusan: mhs ? mhs.prodi : 'Teknik Informatika',
                kurikulum: '2020',
                nama: mhs ? mhs.nama : 'Mahasiswa Demo',
                nim: nim,
                semester: semesters.length > 0 ? Math.max(...semesters) : 7,
                ta: '2024/2025'
            },
            OptSemester: semesters.map(s => ({ semester: s })),
            checklist: [],
            idbatalmk: []
        });
    }

    getBatal = (e) => {
        this.setState({ isLoading: true });

        // Demo: no batal data
        setTimeout(() => {
            this.setState({
                listBatal: { data: [] },
                selectedSemester: e.target.value,
                isLoading: false,
                checklist: [],
                idbatalmk: []
            });
        }, 300);
    }

    toggleCheckbox = (event) => {
        if (event.target.checked) {
            this.state.idbatalmk.push(event.target.value)
        } else {
            var index = this.state.idbatalmk.indexOf(event.target.value);
            this.state.idbatalmk.splice(index, 1);
        }
    }

    setButton = (type) => {
        if (this.state.idbatalmk.length === 0) {
            swal({ icon: 'warning', title: 'Peringatan', text: 'Pilih data terlebih dahulu!' });
        } else {
            swal({
                icon: 'success',
                title: 'Demo Mode',
                text: `Pembatalan berhasil di${type} (simulasi)`,
                timer: 1500,
                buttons: false
            });
        }
    }

    setParams = () => {
        const queryParams = new URLSearchParams(window.location.search);
        this.setState({
            idVal: queryParams.get('id'),
            nimVal: queryParams.get('nim')
        }, () => {
            this.getAllData();
        })
    }

    componentDidMount = () => {
        document.getElementById("batalMK").classList.add("active");
        CollapseMenu();
        this.setParams()
    };

    render() {

        const { angkatan, jurusan, nama, nim, semester, ta } = this.state.user
        const { OptSemester, isLoading, selectedSemester } = this.state
        const { data } = this.state.listBatal

        const statusTheme = (val) => {
            if (val === 'Disetujui') return 'success'
            else if (val === 'Ditolak') return 'danger'
            else return 'primary'
        }

        return (
            <Fragment>
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-12 col-xl-8 mb-xl-0">
                            <p
                                className="abu"
                                style={{
                                    fontSize: "15px",
                                    fontWeight: "bold",
                                    color: "#999999",
                                    textTransform: "capitalize",
                                }}
                            >
                                Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Data Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;
                                Detail Pembatalan KRS
                            </p>
                        </div>
                        <div className="col-12 col-xl-4 sm-md-none">
                            <div className="justify-content-end d-flex ">
                                <div
                                    style={{ cursor: "pointer" }}
                                    title="expand/minimize"
                                    id="toogleMenu"
                                >
                                    <i className="fa fa-expand abu" id="iconQ"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row" id="smoothMain">
                    <div className="col-xl-3 order-xl-2 smoothTabs" id="menuKanan">
                        <MenuDetail id={this.state.idVal} nim={this.state.nimVal} />
                    </div>
                    <div className="col-xl-9" id="kontenKiri">
                        <div className="smooth mb-2">

                            {/* mata kuliah dibatalkan */}
                            <div className="card card-custom">
                                <div className="card-body">
                                    <p className="card-title text-center" style={{ fontSize: "25px", marginTop: "10px", marginBottom: "35px" }}>
                                        Pembatalan KRS
                                    </p>
                                    <div className="table-responsive pl-2 pr-2">
                                        <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                                            <thead></thead>
                                            <tbody>
                                                <tr>
                                                    <td>NIM</td>
                                                    <td> : </td>
                                                    <td>{nim}</td>

                                                    <td>Angkatan</td>
                                                    <td> : </td>
                                                    <td>{angkatan}</td>
                                                </tr>
                                                <tr>
                                                    <td>Nama</td>
                                                    <td> : </td>
                                                    <td>{nama}</td>

                                                    <td>Tahun Akademik</td>
                                                    <td> : </td>
                                                    <td>{ta}</td>
                                                </tr>
                                                <tr>
                                                    <td>Prodi</td>
                                                    <td> : </td>
                                                    <td>{jurusan}</td>
                                                    <td>Semester</td>
                                                    <td> : </td>
                                                    <td>
                                                        <select onChange={this.getBatal} className="form-control custom-width" id="selectSemester" disabled={this.state.isLoading}>
                                                            <option value="" hidden>- pilih semester -</option>
                                                            {
                                                                OptSemester.map((v, index) => {
                                                                    return (
                                                                        <option key={index} value={v.semester}>{'Semester ' + v.semester}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <br />
                                    <br />
                                    <div className="table-responsive pl-2 pr-2 mt-3">
                                        {this.state.isLoading ?
                                            <div id="loaderMhs">
                                                <div className="loader-1 colorful mt-5 mb-2">
                                                    <div className="dot" />
                                                    <div className="dot" />
                                                    <div className="dot" />
                                                </div>
                                                <p align="center" className="mb-5">loading data...</p>
                                            </div>
                                            :

                                            <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            Pilih
                                                        </th>
                                                        <th>No</th>
                                                        <th>Kode MK</th>
                                                        <th>Mata Kuliah</th>
                                                        <th>Dosen Pengajar</th>
                                                        <th>SKS Teori</th>
                                                        <th>SKS Praktek</th>
                                                        <th>Status</th>
                                                        <th>Keterangan</th>
                                                        <th>User</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        data.map((list, i) => {
                                                            return (
                                                                <tr key={i}>
                                                                    <td>
                                                                        <input type="checkbox"
                                                                            disabled={this.state.isLoading}
                                                                            onChange={(e) => this.toggleCheckbox(e, i)}
                                                                            value={list.id}
                                                                            className="cekKRS"
                                                                        />
                                                                    </td>
                                                                    <td>{i + 1}</td>
                                                                    <td>{list.kodemk}</td>
                                                                    <td>{list.matkul}</td>
                                                                    <td>{list.dosen}</td>
                                                                    <td>{list.skstoeri}</td>
                                                                    <td>{list.skspraktek}</td>
                                                                    <td><span className={`badge badge-${statusTheme(list.status)}`} style={{ fontSize: '14px' }}>{list.status}</span></td>
                                                                    <td>{list.alasan}</td>
                                                                    <td>{list.admin}</td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        }
                                    </div>
                                    <br />
                                    <p align="right">
                                        <button onClick={() => this.setButton(statusBatalMK.setuju)} id="" className="btn btn-success" >
                                            Setujui
                                        </button>
                                        &nbsp;&nbsp;
                                        <button onClick={() => this.setButton(statusBatalMK.tolak)} id="" className="btn btn-warning">
                                            Tolak
                                        </button>
                                    </p>
                                </div>
                            </div>
                            {/* end mata kuliah dibatalkan  */}

                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default HistoryBatal
